import { gql } from '@apollo/client';

export const GET_PROFILE_USER_CARDS = gql`
  query ProfileUserCards {
    cards {
      id
      expiry
      issuer
      name
      pan
      isActive
      isExpired
      isPrimary
      system
      iconUrl
      token
    }
  }
`;
